import React from 'react';
import './css/share-code.css';
import bj from './image/bj3.png';

document.title = '老板商学院';

const Menu3 = () => <div className="menuBackground"><img src={bj} alt="bj3" /></div>;

export default Menu3;
